import { Directive, ElementRef, Host, Input, OnDestroy } from '@angular/core';
import { fromEvent, merge, Subscription } from 'rxjs';

@Directive({
  selector: '[appBlockModalDrag]',
})
export class BlockModalDragDirective implements OnDestroy {
  private _enabled: boolean;

  @Input('appBlockModalDrag')
  get enabled() {
    return this._enabled;
  }

  set enabled(value) {
    value = !!value;
    if (this._enabled !== value) {
      this._enabled = value;
      if (this.enabled) {
        this.enableBlockingEvents();
      } else {
        this.blockingEventsSubscription?.unsubscribe();
      }
    }
  }

  private blockingEventsSubscription: Subscription;

  constructor(@Host() private elementRef: ElementRef<HTMLElement>) {}

  ngOnDestroy(): void {
    this.blockingEventsSubscription?.unsubscribe();
  }

  private enableBlockingEvents() {
    const eventNameList = ['mousedown', 'touchstart'];
    this.blockingEventsSubscription = merge(
      ...eventNameList.map((eventName) =>
        fromEvent(this.elementRef.nativeElement, eventName)
      )
    ).subscribe((e) => {
      e.stopPropagation();
    });
  }
}
